export interface ColorPalettePreset {
  id: string;
  name: string;
  description: string;
  colors: string[];
}

export const BUILTIN_PALETTES: ColorPalettePreset[] = [
  {
    id: 'dawnbringer16',
    name: 'Dawnbringer 16',
    description: 'Perfect balance, 16 colors',
    colors: [
      '#140c1c','#442434','#30346d','#4e4a4e',
      '#854c30','#346524','#d04648','#757161',
      '#597dce','#d27d2c','#8595a1','#6daa2c',
      '#d2aa99','#6dc2ca','#dad45e','#deeed6'
    ]
  },
  {
    id: 'dawnbringer32',
    name: 'Dawnbringer 32',
    description: 'Extended DawnBringer, 32 colors',
    colors: [
      '#000000','#222034','#45283c','#663931',
      '#8f563b','#df7126','#d9a066','#eec39a',
      '#fbf236','#99e550','#6abe30','#37946e',
      '#4b692f','#524b24','#323c39','#3f3f74',
      '#306082','#5b6ee1','#639bff','#5fcde4',
      '#cbdbfc','#ffffff','#9badb7','#847e87',
      '#696a6a','#595652','#76428a','#ac3232',
      '#d95763','#d77bba','#8f974a','#8a6f30'
    ]
  },
  {
    id: 'endesga32',
    name: 'Endesga 32',
    description: 'Vibrant modern pixel art',
    colors: [
      '#be4a2f','#d77643','#ead4aa','#e4a672',
      '#b86f50','#733e39','#3e2731','#a22633',
      '#e43b44','#f77622','#feae34','#fee761',
      '#63c74d','#3e8948','#265c42','#193c3e',
      '#124e89','#0099db','#2ce8f5','#ffffff',
      '#c0cbdc','#8b9bb4','#5a6988','#3a4466',
      '#262b44','#181425','#ff0044','#68386c',
      '#b55088','#f6757a','#e8b796','#c28569'
    ]
  },
  {
    id: 'endesga36',
    name: 'Endesga 36',
    description: 'Endesga extended, 36 colors',
    colors: [
      '#be4a2f','#d77643','#ead4aa','#e4a672',
      '#b86f50','#733e39','#3e2731','#a22633',
      '#e43b44','#f77622','#feae34','#fee761',
      '#63c74d','#3e8948','#265c42','#193c3e',
      '#124e89','#0099db','#2ce8f5','#ffffff',
      '#c0cbdc','#8b9bb4','#5a6988','#3a4466',
      '#262b44','#181425','#ff0044','#68386c',
      '#b55088','#f6757a','#e8b796','#c28569',
      '#4d2b32','#7a3045','#b04b5c','#d4736f'
    ]
  },
  {
    id: 'pico8',
    name: 'Pico-8',
    description: 'Iconic retro, 16 colors',
    colors: [
      '#000000','#1d2b53','#7e2553','#008751',
      '#ab5236','#5f574f','#c2c3c7','#fff1e8',
      '#ff004d','#ffa300','#ffec27','#00e436',
      '#29adff','#83769c','#ff77a8','#ffccaa'
    ]
  },
  {
    id: 'zughy32',
    name: 'Zughy 32',
    description: 'Game dev friendly, 32 colors',
    colors: [
      '#212123','#3a3858','#4a3f6b','#6b4c82',
      '#9b5b9b','#c46ba0','#e88fa8','#f5c5c5',
      '#f5e6c5','#e8c87a','#c49a3a','#8a6b2a',
      '#5a4020','#3a2810','#6b4a30','#9b6b4a',
      '#c88a5a','#e8b07a','#f5d09a','#c4e88a',
      '#8ac44a','#5a9a2a','#3a6a1a','#1a4a0a',
      '#1a6a5a','#2a9a7a','#3ac4a0','#5ae4c0',
      '#8af0d8','#4a9ab4','#2a6a8a','#1a3a5a'
    ]
  },
  {
    id: 'cc29',
    name: 'CC-29',
    description: 'Versatile 29-color set',
    colors: [
      '#1a1c2c','#5d275d','#b13e53','#ef7d57',
      '#ffcd75','#a7f070','#38b764','#257179',
      '#29366f','#3b5dc9','#41a6f6','#73eff7',
      '#f4f4f4','#94b0c2','#566c86','#333c57',
      '#ff0000','#ff6600','#ffff00','#00ff00',
      '#00ffff','#0000ff','#ff00ff','#ffffff',
      '#aaaaaa','#555555','#000000','#884400','#ff8844'
    ]
  },
  {
    id: 'pastel16',
    name: 'Pastel / Crayon 16',
    description: 'Soft, charming character design',
    colors: [
      '#f8b4b4','#f8d4b4','#f8f4b4','#d4f8b4',
      '#b4f8b4','#b4f8d4','#b4f4f8','#b4d4f8',
      '#b4b4f8','#d4b4f8','#f8b4f8','#f8b4d4',
      '#ffffff','#d8d8d8','#a8a8a8','#404040'
    ]
  },
  {
    id: 'nes',
    name: 'NES System',
    description: 'Nintendo Entertainment System',
    colors: [
      '#7c7c7c','#0000fc','#0000bc','#4428bc',
      '#940084','#a80020','#a81000','#881400',
      '#503000','#007800','#006800','#005800',
      '#004058','#000000','#000000','#000000',
      '#bcbcbc','#0078f8','#0058f8','#6844fc',
      '#d800cc','#e40058','#f83800','#e45c10',
      '#ac7c00','#00b800','#00a800','#00a844',
      '#008888','#000000','#000000','#000000',
      '#f8f8f8','#3cbcfc','#6888fc','#9878f8',
      '#f878f8','#f85898','#f87858','#fca044',
      '#f8b800','#b8f818','#58d854','#58f898',
      '#00e8d8','#787878','#000000','#000000',
      '#fcfcfc','#a4e4fc','#b8b8f8','#d8b8f8',
      '#f8b8f8','#f8a4c0','#f0d0b0','#fce0a8',
      '#f8d878','#d8f878','#b8f8b8','#b8f8d8',
      '#00fcfc','#f8d8f8','#000000','#000000'
    ]
  },
  {
    id: 'gameboy',
    name: 'Game Boy',
    description: 'Classic 4-color Game Boy',
    colors: ['#0f380f','#306230','#8bac0f','#9bbc0f']
  },
];

export interface CustomPalette {
  id: string;
  name: string;
  colors: string[];
}
